"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.calcFtIn = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./utils");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
var _ui = require("@evidation/ui");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HeightSelect = (0, _styledComponents["default"])(_formElements.SelectInput).withConfig({
  displayName: "fieldHeight__HeightSelect"
})(["width:50%;"]);
var ftOptions = [{
  label: "3'",
  value: 3
}, {
  label: "4'",
  value: 4
}, {
  label: "5'",
  value: 5
}, {
  label: "6'",
  value: 6
}, {
  label: "7'",
  value: 7
}];
var inOptions = [{
  label: "0\"",
  value: 0
}, {
  label: "1\"",
  value: 1
}, {
  label: "2\"",
  value: 2
}, {
  label: "3\"",
  value: 3
}, {
  label: "4\"",
  value: 4
}, {
  label: "5\"",
  value: 5
}, {
  label: "6\"",
  value: 6
}, {
  label: "7\"",
  value: 7
}, {
  label: "8\"",
  value: 8
}, {
  label: "9\"",
  value: 9
}, {
  label: "10\"",
  value: 10
}, {
  label: "11\"",
  value: 11
}];
var calcFtIn = exports.calcFtIn = function calcFtIn() {
  var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    ft: Math.floor(v / 12),
    inch: v % 12
  };
};
var calcTotalIn = function calcTotalIn(_ref) {
  var ft = _ref.ft,
    inch = _ref.inch;
  if (isNaN(ft) || isNaN(inch)) {
    return undefined;
  }
  return ft * 12 + inch;
};
var HeightSelector = /*#__PURE__*/function (_PureComponent) {
  function HeightSelector(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, HeightSelector);
    _this = _callSuper(this, HeightSelector, [props]);
    (0, _defineProperty2["default"])(_this, "onChange", function (value, id) {
      var _this$props$input = _this.props.input,
        onChange = _this$props$input.onChange,
        onBlur = _this$props$input.onBlur;
      _this.setState(id === 'ft' ? {
        ft: value
      } : {
        inch: value
      }, function () {
        onBlur();
        onChange(calcTotalIn(_this.state));
      });
    });
    var _ref2 = props.input.value ? calcFtIn(props.input.value) : {},
      ft = _ref2.ft,
      inch = _ref2.inch;
    _this.state = {
      ft: ft,
      inch: inch === 0 ? undefined : inch
    };
    return _this;
  }

  // needed to include previous contributions in submitted data after go-back
  (0, _inherits2["default"])(HeightSelector, _PureComponent);
  return (0, _createClass2["default"])(HeightSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$input2;
      if ((_this$props$input2 = this.props.input) !== null && _this$props$input2 !== void 0 && _this$props$input2.value) {
        this.props.input.onBlur(calcTotalIn(this.state));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2,
        _this$props2$meta,
        _this2 = this,
        _this$props3,
        _this$props3$meta;
      var _this$props = this.props,
        labelStyle = _this$props.labelStyle,
        _onBlur = _this$props.input.onBlur,
        inputStyle = _this$props.inputStyle,
        label = _this$props.label,
        _this$props$config$re = _this$props.config.required,
        required = _this$props$config$re === void 0 ? false : _this$props$config$re,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
        t = _this$props.t,
        error = _this$props.error,
        touched = _this$props.touched;
      var _this$state = this.state,
        ft = _this$state.ft,
        inch = _this$state.inch;
      var feetText = "".concat(t('components.fieldHeight.feet'));
      var inchText = "".concat(t('components.fieldHeight.inch'));
      var placeholder = t('components.select.placeholder');
      return /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
        items: "center",
        fullWidth: true,
        spaceX: 4
      }, /*#__PURE__*/_react["default"].createElement(HeightSelect, {
        className: "height ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        id: "t-height_ft",
        name: "t-height_ft",
        "data-test-id": "t-height_ft",
        inputStyle: inputStyle,
        options: ftOptions,
        label: feetText,
        position: "inline-label-after",
        error: error && ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$meta = _this$props2.meta) === null || _this$props2$meta === void 0 ? void 0 : _this$props2$meta.touched),
        onChange: function onChange(value) {
          if (value === feetText) {
            value = undefined;
          }
          _this2.onChange(value, 'ft');
        },
        onBlur: function onBlur() {
          _onBlur(calcTotalIn(_this2.state));
        },
        value: ft,
        disabled: disabled,
        convertValuesToStrings: false,
        initialValue: placeholder
      }), /*#__PURE__*/_react["default"].createElement(HeightSelect, {
        className: "height ".concat((0, _utils.constructFieldClassname)(this.props.meta)),
        id: "t-height_inch",
        name: "t-height_inch",
        label: inchText,
        "data-test-id": "t-height_inch",
        position: "inline-label-after",
        inputStyle: inputStyle,
        options: inOptions,
        error: error && ((_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$meta = _this$props3.meta) === null || _this$props3$meta === void 0 ? void 0 : _this$props3$meta.touched),
        onChange: function onChange(value) {
          if (value === inchText) {
            value = undefined;
          }
          _this2.onChange(value, 'inch');
        },
        value: inch,
        onBlur: function onBlur() {
          _onBlur(calcTotalIn(_this2.state));
        },
        disabled: disabled,
        convertValuesToStrings: false,
        initialValue: placeholder
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(HeightSelector);